import { useFeature } from 'FeatureProvider';
import useEnvironment from 'hooks/useEnvironment';
import useUserStore from 'hooks/useUserStore';

/**
 * Access rules for the inventories module, shared by the sidebar, the /inventories entry and both
 * module variants so they cannot drift apart.
 *
 * The rules are kept separate on purpose: the sidebar shows the item without a license, so the
 * no-license screen works as an upsell, while the routes require both.
 */
export const useInventoryModuleAccess = () => {
  const { environmentsState } = useEnvironment();
  const {
    storeState: { selected: storeSelected },
  } = useUserStore();
  const hasLicense = useFeature('@module.inventory');

  const isModuleEnabled = environmentsState.REACT_APP_FEATURE_INVENTORY_ENABLED === 'true' && !storeSelected?.isDraft;

  return { hasLicense, hasModuleAccess: isModuleEnabled && hasLicense, isModuleEnabled };
};
